__turbopack_context__.v({
  "error": "TextField-module__JWWsUq__error",
  "hintText": "TextField-module__JWWsUq__hintText",
  "icon": "TextField-module__JWWsUq__icon",
  "input": "TextField-module__JWWsUq__input",
  "inputContainer": "TextField-module__JWWsUq__inputContainer",
  "inputWithLabel": "TextField-module__JWWsUq__inputWithLabel",
  "insideLabel": "TextField-module__JWWsUq__insideLabel",
  "requiredStar": "TextField-module__JWWsUq__requiredStar",
});
